import { normalize, schema } from "normalizr";

export default function(json) {
  const ret = {
    booth: json.booth,
    entities: {}
  };
  // shedulesを正規化
  const schedules = json.schedules;
  const scheduleSchema = new schema.Entity("schedules");
  const normalizedSchedules = normalize(schedules, [scheduleSchema]);
  ret.entities.schedules = normalizedSchedules.entities.schedules;
  ret.schedules = normalizedSchedules.result;

  // sessionsを正規化
  const sessions = json.sessions;
  const sessionSchema = new schema.Entity("sessions");
  const normalizedSessions = normalize(sessions, [sessionSchema]);
  ret.entities.sessions = normalizedSessions.entities.sessions;
  const orderedSessions = [];
  schedules.forEach(s => {
    s.halls.forEach(h => {
      orderedSessions.push(h.session);
    });
  });
  ret.sessions = orderedSessions;

  // speakersを正規化
  const speakers = json.speakers;
  const speakerSchema = new schema.Entity("speakers");
  const normalizedSpeakers = normalize(speakers, [speakerSchema]);
  ret.entities.speakers = normalizedSpeakers.entities.speakers;
  ret.speakers = normalizedSpeakers.result;

  // categoriesを正規化
  const categories = json.categories;
  const categorySchema = new schema.Entity("categories");
  const normalizedCategories = normalize(categories, [categorySchema]);
  ret.entities.categories = normalizedCategories.entities.categories;
  ret.categories = normalizedCategories.result;

  const halls = ["a", "b", "c", "d", "e", "f", "g", "h", "i"];
  json.schedules.forEach(s => {
    // sessionsにscheduleIdを追加する
    // sessionsにhallIdを追加する
    s.halls.forEach((h, idx) => {
      const scheduleId = s.id;
      const session = ret.entities.sessions[h.session];
      session.scheduleId = scheduleId;
      session.hallId = `hall_${halls[idx]}`;
    });
  });

  return ret;
}
